import { useEffect, } from 'react';
import { useSetState, useMountedState, } from 'react-use';
import { db, } from '../firebase/config';
import { doc, onSnapshot, } from 'firebase/firestore';

export const useDocument = ({ col, id, uid, }) => {
    const [state, setState] = useSetState({
        document: null,
        isPending: false,
        error: null,
    });
    const isMounted = useMountedState();

    useEffect(() => {
        setState({
            document: null,
            isPending: true,
            error: null,
        });

        const unsub = onSnapshot(doc(db, col, id), (document) => {
            if (isMounted()) {
                if (document.exists()) {
                    const data = { ...document.data(), id: document.id, };

                    if (uid === undefined) {
                        setState({
                            document: data,
                        });
                    }

                    if (uid && uid === data.uid) {
                        setState({
                            document: data,
                        });
                    } else {
                        setState({
                            error: new Error('Доступ запрещён'),
                        });
                    }
                }
                setState({
                    isPending: false,
                });
            }
        }, (error) => {
            if (isMounted()) {
                setState({
                    document: null,
                    isPending: false,
                    error,
                });
            }
        });

        return () => unsub();
    }, [col, id]);

    return state;
};